<template>
    <div id="InfoRelease">
        <div class="breadcrumb">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>发布内容</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="release-content">
            <div class="release-content-box">
                <div>栏目</div>
                <el-select placeholder="请选择发帖类型" v-model="form.type">
                    <el-option
                        v-for="(type, index) of typeList"
                        :label="type.dictLabel"
                        :value="type.dictValue"
                        :key="index"></el-option>
                </el-select>
            </div>
            <div class="release-content-box">
                <div>标题</div>
                <el-input placeholder="请输入内容" v-model="form.title"></el-input>
            </div>
            <div class="release-content-box upload-box">
                <div>缩略图</div>
                <div class="pre-img" v-if="form.imgUrl">
                    <img :src="form.imgUrl" alt="">
                    <i class="el-icon-error" @click="deleteImg"></i>
                </div>
                <div class="upload" @click="upLoadImage" v-show="!form.imgUrl">
                    <img src="../../assets/img/加号.png" alt="">
                    <p>点击添加图片</p>
                </div>
                <input
                    style="display: none"
                    ref="input"
                    type="file"
                    accept="image/gif, image/jpeg, image/jpg, image/png, image/svg"
                    multiple="multiple"
                    @change="handleFileChange"
                >
            </div>
            <div class="release-content-box upload-box quill-box" v-show="form.type !== '1'">
                <div>内容</div>
                <quillEditor class="quill" v-model="form.content"></quillEditor>
            </div>
            <div class="release-content-box video-box" v-show="form.type === '1'">
                <div>视频</div>
                <el-upload
                    class="upload-demo"
                    ref="upload"
                    :action="$common.BASE_URL + '/hdweb/portal/upload'"
                    :before-upload="beforeUpload"
                    :on-success="success"
                    :on-error="error"
                    :on-change="handleVideoChanges"
                    :file-list="fileList" accept="video/*">
                    <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传视频文件</div>
                </el-upload>
            </div>
            <div class="btn-box">
                <div @click="submit">提交</div>
                <!--                <div>保存草稿</div>-->
            </div>
        </div>
    </div>
</template>

<script>

    import {quillEditor} from 'vue-quill-editor'

    export default {
        name: 'InfoRelease',
        components: {quillEditor},
        data() {
            return {
                // 内容
                content: '',
                // 类型列表
                typeList: [],
                // 文件列表
                fileList: [],
                form: {
                    // 类型
                    type: '',
                    // 标题
                    title: '',
                    profile: '',
                    // 内容和
                    content: '',
                    // 图片url
                    imgUrl: '',
                    // 视频url
                    videoUrl: '',
                    loading: ''
                }
            }
        },
        methods: {
            /**
             * 获得帖子类型
             */
            getType() {
                this.$common.querystringifyPost('/hdweb/common/getDictByType', {
                    type: 'posting_type'
                }).then(res => {
                    this.typeList = res.data
                })
            },
            /**
             * 上传图片
             */
            upLoadImage() {
                this.$refs.input.click()
            },
            handleFileChange(event) {
                this.$common.uploadData('/hdweb/portal/upload', {file: event.target.files[0]}).then(res => {
                    if (res.data.code === 0) {
                        // this.$set(this.form.imgUrl, res.data.data)
                        this.form.imgUrl = res.data.data
                    }
                })
            },
            submitUpload() {
                this.$refs.upload.submit()
            },
            /**
             * 上传成功
             */
            success(response) {
                this.loading.close()
                if (response.code === 0) {
                    this.$message.success(response.msg)
                    this.form.videoUrl = response.data
                } else {
                    this.$message.error(response.msg)
                }
            },
            error(err) {
                console.log(err)
                this.loading.close()
                this.$message.error('网络错误上传失败')
            },
            /**
             * 上传之前判断文件类型
             */
            beforeUpload(file) {
                let fileType = ['video/mp4', 'video/x-matroska']
                if (!fileType.includes(file.type)) {
                    this.$message.error('请上传视频格式文件')
                    return false
                } else {
                    this.loading = this.$loading({
                        lock: true,
                        text: '上传文件中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    })
                }
            },
            /**
             * 发部帖子
             */
            submit() {
                // 视频
                if (!this.form.type) {
                    this.$message.error('请选择帖子类型')
                    return false
                } else if (!this.form.title) {
                    this.$message.error('请填写标题')
                    return false
                } else if (!this.form.imgUrl) {
                    this.$message.error('请上传缩略图')
                    return false
                } else if (this.form.type === '1') {
                    if (!this.form.videoUrl) {
                        this.$message.error('请上传视频')
                        return false
                    }
                } else if (this.form.type && this.form.type !== '1') {
                    if (!this.form.content) {
                        this.$message.error('请填写文章内容')
                        return false
                    }
                }
                this.$common.post('/hdweb/portal/savePosting', this.form).then(res => {
                    if (res.data.code === 0) {
                        this.$message.success('发布成功')
                        this.$router.replace('/MyPost')
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            },
            /**
             * 删除图片
             */
            deleteImg() {
                this.$refs.input.value = ''
                this.form.imgUrl = ''
            },
            handleVideoChanges(file, fileList) {
                if (fileList.length > 1) {
                    fileList.splice(0, 1)
                }
            }
            // exceed() {
            //     this.$message.error('只能上传一个视频')
            // }
        },
        created() {
            this.getType()
        },
        watch: {
            // 监听帖子类型
            'form.type': {
                handler(val) {
                    console.log(val)
                    this.form.imgUrl = ''
                    this.form.videoUrl = ''
                    this.fileList = []
                },
                deep: true
            }
        }
    }
</script>

<style scoped lang="less">
    #InfoRelease {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 100px;

        .breadcrumb {
            margin: 25px 0;
        }

        .release-content {
            width: 1100px;
            margin: 0 auto;

            .release-content-box {
                margin-top: 24px;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                > div:nth-of-type(1) {
                    width: 42px;
                    margin-right: 15px;
                    text-align: right;
                }

                .pre-img {
                    width: 216px;
                    height: 142px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    position: relative;

                    > img {
                        width: 100%;
                        /*height: 100%;*/
                    }

                    > i {
                        position: absolute;
                        top: 5px;
                        right: 5px;
                        color: white;
                        font-size: 20px;
                    }
                }

                .upload {
                    width: 216px;
                    height: 142px;
                    background: rgb(248, 248, 248);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    img {
                        width: 25px;
                        margin-bottom: 10px;
                    }
                }
            }

            .upload-box {
                display: flex;
                align-items: flex-start;
            }

            .quill-box {
                height: 450px;

                .quill {
                    width: 880px;
                    height: 362px;
                }
            }

            .video-box {
                display: flex;
                align-items: flex-start;
                height: 150px;
            }
        }

        .btn-box {
            padding-left: 57px;
            display: flex;

            > div {
                width: 80px;
                height: 34px;
                border: 1px solid rgba(204, 204, 204, 1);
                border-radius: 4px;
                text-align: center;
                line-height: 34px;
                margin-right: 15px;

                &:hover {
                    background: rgba(5, 160, 130, 1);
                    color: white;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/release/InfoRelease.vue